const API_BASE_URL = 'https://agrimocksbe.onrender.com/api';
const API_BASE_URL_LOCAL = 'http://localhost:5001/api';
const API_URL = API_BASE_URL;

interface ApiResponse<T> {
  status: 'success' | 'error';
  message?: string;
  token?: string;
  data?: {
    user: T;
  };
}

export async function fetchApi<T>(
  endpoint: string,
  options: RequestInit = {}
): Promise<ApiResponse<T>> {
  const token = localStorage.getItem('token');
  
  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Something went wrong');
  }

  return data;
}

// Category Management
export const getCategories = () => fetchApi('/quiz/categories');
export const createCategory = (body: any) => fetchApi('/categories', { method: 'POST', body: JSON.stringify(body) });
export const updateCategory = (id: string, body: any) => fetchApi(`/categories/${id}`, { method: 'PUT', body: JSON.stringify(body) });
export const deleteCategory = (id: string) => fetchApi(`/categories/${id}`, { method: 'DELETE' });

// Question Management
export const getQuestionsByCategory = (categoryId: string) => fetchApi(`/quiz/categories/${categoryId}/questions`);
export const getQuestionsByCategorySlug = (categorySlug: string) => fetchApi(`/quiz/categories/slug/${categorySlug}/questions`);
export const createQuestion = (body: any) => fetchApi('/quiz/questions', { method: 'POST', body: JSON.stringify(body) });
export const createQuestionsBulk = (body: any) => fetchApi('/quiz/questions/bulk', { method: 'POST', body: JSON.stringify(body) });
export const updateQuestion = (id: string, body: any) => fetchApi(`/quiz/questions/${id}`, { method: 'PUT', body: JSON.stringify(body) });
export const deleteQuestion = (id: string) => fetchApi(`/quiz/questions/${id}`, { method: 'DELETE' }); 